"use client";

import IconLabel from "@/icons/IconLabel";
import DesignAction from "./DesignAction";

import { CtaComponentProps } from "@/cms/models";
import Link from "next/link";
import RippleCtaButton from "./RippleCtaButton";
import PageDialogLink from "@/components/page-dialog/PageDialogLink";

/** With `onClick` the button acts on the page, such as opening a dialog, instead of following `config.link`. */
export default function RippleCtaButtonComponent(props: {
  config: CtaComponentProps;
  id: string;
  itemIndex: number;
  onClick?: () => void;
  "aria-haspopup"?: "dialog";
}) {
  if (props.config.variant)
    return (
      <DesignAction
        config={props.config}
        onClick={props.onClick}
        aria-haspopup={props["aria-haspopup"]}
      />
    );
  const button = (
    <RippleCtaButton {...props}>
      <IconLabel
        iconId={props.config.iconId}
        position={props.config.iconPosition}
        lookSystem={props.config.lookSystem}
      >
        {props.config.label}
      </IconLabel>
    </RippleCtaButton>
  );
  if (props.onClick) return button;
  return props.config.pageDialog ? (
    <PageDialogLink href={props.config.link} dialog={props.config.pageDialog}>
      {button}
    </PageDialogLink>
  ) : (
    <Link href={props.config.link}>{button}</Link>
  );
}
